import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const ProductPrice = ({ articleNumber, prices, currency }) => {
    const priceList = JSON.parse(prices);
    const [price, setPrice] = useState(priceList[0].formattedPrice);
    const [priceWithVat, setPriceWithVat] = useState(
        priceList[0].formattedPriceWithVat
    );
    const quantity = useSelector(
        (state) =>
            (state.cart.productQuantity &&
                state.cart.productQuantity.quantity &&
                state.cart.productQuantity.quantity) ||
            1
    );
    const articleNumberState = useSelector(
        (state) =>
            (state.cart.productQuantity &&
                state.cart.productQuantity.articleNumber &&
                state.cart.productQuantity.articleNumber) ||
            ''
    );

    useEffect(() => {
        priceList.map((interval) => {
            if (
                articleNumber == articleNumberState &&
                quantity >= interval.minimumQuantity &&
                quantity <= interval.nextMinimumQuantity
            ) {
                setPrice(interval.formattedPrice);
                setPriceWithVat(interval.formattedPriceWithVat);
            } else if (
                articleNumber == articleNumberState &&
                quantity >= interval.minimumQuantity &&
                interval.nextMinimumQuantity == null
            ) {
                setPrice(interval.formattedPrice);
                setPriceWithVat(interval.formattedPriceWithVat);
            }
        });
    }, [quantity, price, priceList, articleNumber, articleNumberState]);

    return (
        <div className="price">
            {price}
            <span className="product-detail__price-info-with-vat">
                {' (' + priceWithVat + ' ' + translate('price.withvat') + ')'}
            </span>
        </div>
    );
};

export default ProductPrice;
